import ServiceDetail from '@/components/feature/ServiceDetail';

export default function SeoMarketingPage() {
  return <ServiceDetail slug="seo-marketing" />;
}